module.exports = __webpack_public_path__ + "img/product7.1c0e81eb.jpg";